import React from 'react';
import { useTranslation } from "react-i18next";

const getUseCases = (t: (key: string) => string) => [
  { title: t('ai-case-1-title'), desc: t('ai-case-1-desc'), img: 'ai_1.png' },
  { title: t('ai-case-2-title'), desc: t('ai-case-2-desc'), img: 'ai_2.png' },
  { title: t('ai-case-3-title'), desc: t('ai-case-3-desc'), img: 'ai_3.png' },
  { title: t('ai-case-4-title'), desc: t('ai-case-4-desc'), img: 'ai_4.png' },
  { title: t('ai-case-5-title'), desc: t('ai-case-5-desc'), img: 'ai_5.png' },
  { title: t('ai-case-6-title'), desc: t('ai-case-6-desc'), img: 'ai_6.png' },
];

export const AIUseCases: React.FC = () => {
  const { t } = useTranslation();
  const useCases = getUseCases(t);

  return (
    <section className="section-page">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="mx-auto mb-4 max-w-[min(100%,56rem)] text-balance text-2xl font-bold leading-snug text-white md:text-3xl">
            {t('ai-title-line1')}
            <br />
            {t('ai-title-line2')}
          </h2>
          <p className="mx-auto max-w-4xl text-pretty text-base leading-relaxed text-white/80">
            {t('ai-desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {useCases.map((c, i) => (
            <div key={i} className="group overflow-hidden rounded-2xl border border-[#979797]/30 bg-gradient-to-b from-[#D7D7D7]/5 to-transparent transition-[border-color,box-shadow] duration-300 ease-out hover:border-[#8A43FF]/40 hover:shadow-lg hover:shadow-[#8A43FF]/5">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={new URL(`../assets/figma/${c.img}`, import.meta.url).href} alt={c.title} className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]" />
              </div>
              <div className="p-5">
                <h3 className="mb-2 text-xl text-white">{c.title}</h3>
                <p className="text-pretty leading-relaxed text-[#B9B9B9] text-sm sm:text-base">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
